module.exports = __webpack_public_path__ + "static/media/knight_armor.4e248fab.png";